import React, { useState } from "react";

const TaskFilter = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="mt-4 border h-screen rounded-md p-2">
      <div className="text-[16px] text-[#828282]">FILTERS</div>
      <div>
        <div
          onClick={toggleAccordion}
          style={{ cursor: "pointer" }}
          className="flex items-center justify-between"
        >
          <p className="text-[12px] font-bold">Task Type</p>

          <div
            style={{
              transform: isOpen ? "rotate(180deg)" : "rotate(0)",
            }}
            className="text-[30px] pr-2"
          >
            &#8964; {/* Down arrowhead*/}
          </div>
        </div>

        {isOpen && (
          <div className="flex flex-col">
            <p className="text-[10px] mb-2">Types</p>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Follow Up</p>
            </label>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Pending Visits</p>
            </label>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Send Docs</p>
            </label>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Sample Tasks</p>
            </label>

            {/* Sub-Task Types */}
            <p className="text-[10px] mb-2 mt-2">Sub-task Types</p>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Call</p>
            </label>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Mail</p>
            </label>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Message</p>
            </label>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Brochures</p>
            </label>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Catalogue</p>
            </label>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Invites</p>
            </label>
          </div>
        )}
      </div>

      <div>
        <div
          style={{ cursor: "pointer" }}
          className="flex items-center justify-between"
        >
          <p className="text-[12px] font-bold">Store/Company</p>

          <div
            style={{
              transform: isOpen ? "rotate(180deg)" : "rotate(0)",
            }}
            className="text-[30px] pr-2"
          >
            &#8964; {/* Down arrowhead*/}
          </div>
        </div>
      </div>
      <div>
        <div
          style={{ cursor: "pointer" }}
          className="flex items-center justify-between"
        >
          <p className="text-[12px] font-bold">Event/Exhibition</p>

          <div
            style={{
              transform: isOpen ? "rotate(180deg)" : "rotate(0)",
            }}
            className="text-[30px] pr-2"
          >
            &#8964; {/* Down arrowhead*/}
          </div>
        </div>
      </div>
      <div>
        <div
          style={{ cursor: "pointer" }}
          className="flex items-center justify-between"
        >
          <p className="text-[12px] font-bold">Contact Person</p>

          <div
            style={{
              transform: isOpen ? "rotate(180deg)" : "rotate(0)",
            }}
            className="text-[30px] pr-2"
          >
            &#8964; {/* Down arrowhead*/}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskFilter;
